export enum AdminMarketplaceTab {
    Engagements = 1,
    TimelineTemplates = 2,
    MarketplaceBuyers = 3,
    DocumentTemplates = 4,
    MarketplaceSettings = 5,
}

export const AdminMarketplaceTabs = [
    { id: AdminMarketplaceTab.Engagements, content: 'Engagements' },
    {
        id: AdminMarketplaceTab.TimelineTemplates,
        content: 'Timeline Templates',
    },
    { id: AdminMarketplaceTab.MarketplaceBuyers, content: 'Buyers' },
    {
        id: AdminMarketplaceTab.DocumentTemplates,
        content: 'Document Templates',
    },
    {
        id: AdminMarketplaceTab.MarketplaceSettings,
        content: 'Marketplace Settings',
    },
    // 'Document Center',
    // 'Billing Summary',
    // 'Marketplace Audit Log',
];
